import React from 'react';
import { Stack } from '@chakra-ui/core';

import { TabForm } from '../../../../common/components/Tabs';
import { Notice, NoticeText } from '../../../../common/components/Notice';
import {
  FormSection,
  FormList,
  FormListItem,
  FormSubmitButton,
} from '../../../../common/components/Form/Form';
import { DateInput } from '../../../../common/components/Form/FormDateInput';
import {
  RadioGroup,
  RadioInput,
  SwitchInput,
  TextInput,
} from '../../../../common/components/Form/FormInputs';

export const BlocCTab1 = ({ formik }) => {
  const { anahAccountApplicable, anahAccountOpened, anahReference } = formik.values;
  const anahAccountIncomplete =
    anahAccountApplicable &&
    (!anahAccountOpened || (anahAccountOpened === 'true' && !anahReference?.trim()));

  return (
    <TabForm onSubmit={formik.handleSubmit}>
      <Stack spacing="3.5rem">
        {anahAccountApplicable && (
          <FormSection title="Compte ANAH">
            <RadioGroup
              legend="Le compte ANAH est-il ouvert ?"
              name="anahAccountOpened"
              requiredInput
            >
              <RadioInput value="true">Oui</RadioInput>
              <RadioInput value="false">Non</RadioInput>
            </RadioGroup>
            <TextInput
              label="Référence ANAH"
              name="anahReference"
              id="anahReference"
              disabled={anahAccountOpened !== 'true'}
              requiredInput={anahAccountOpened === 'true'}
            />
          </FormSection>
        )}
        <FormSection title="Liste des prérequis">
          <FormList mb="3.687rem">
            {formik.values.requiredLaunchDocuments &&
              Object.entries(formik.values.requiredLaunchDocuments).map(([key, document]) => (
                <FormListItem key={document.name}>
                  <SwitchInput
                    label={document.name}
                    name={`requiredLaunchDocuments.${key}.isReceived`}
                    id={`requiredLaunchDocuments.${key}.isReceived`}
                  />
                </FormListItem>
              ))}
          </FormList>
          <DateInput
            label="Date de réception des documents"
            name="launchDocumentsReceivedAt"
            id="launchDocumentsReceivedAt"
            disabled={
              anahAccountIncomplete ||
              (formik.values.requiredLaunchDocuments &&
                Object.values(formik.values.requiredLaunchDocuments).some(doc => !doc.isReceived))
            }
          />
          <Notice variant="warning">
            <NoticeText variant="warning">
              Déclarer si besoin le contrat d'AMO avant de le valider
            </NoticeText>
          </Notice>
        </FormSection>
      </Stack>

      <FormSubmitButton
        type="submit"
        disabled={formik.isSubmitting}
        isLoading={formik.isSubmitting}
        loadingText="Enregistrer"
      >
        Enregistrer
      </FormSubmitButton>
    </TabForm>
  );
};
